import { IFileValidator } from "../models/validator";

export class MaxFileSizeValidator implements IFileValidator {
  _maxSize: number;
  constructor(maxSizeInMB: number) {
    this._maxSize = maxSizeInMB * 1000000;
  }

  validate(file?: File | undefined): string | undefined {
    if (file && file.size > this._maxSize) return "Bestand is te groot";
  }
}
